(function(){
  const root = document.querySelector('.ad-videos-section');
  if(!root) return;

  function pauseOthers(except){
    root.querySelectorAll('video.ad-video-el').forEach(v=>{
      if(v!==except){ try{v.pause();}catch(e){} v.closest('.ad-video-wrap')?.classList.remove('is-playing'); }
    });
    root.querySelectorAll('.ad-iframe-lazy.playing iframe').forEach(ifr=>{
      if(ifr!==except){
        const w = ifr.closest('.ad-iframe-lazy');
        ifr.src = 'about:blank';
        w.classList.remove('playing');
        w.closest('.ad-video-wrap')?.classList.remove('is-playing');
        ifr.remove();
      }
    });
  }

  root.querySelectorAll('.ad-video-wrap').forEach(wrap=>{
    const video = wrap.querySelector('video.ad-video-el');
    if(video){
      video.addEventListener('play',()=>{ pauseOthers(video); wrap.classList.add('is-playing'); });
      video.addEventListener('pause',()=> wrap.classList.remove('is-playing'));
      video.addEventListener('ended',()=> wrap.classList.remove('is-playing'));
    }

    const lazy = wrap.querySelector('.ad-iframe-lazy');
    const playBtn = lazy?.querySelector('.ad-play');
    if(playBtn){
      playBtn.addEventListener('click',()=>{
        pauseOthers(null);
        const embed = lazy.getAttribute('data-embed');
        const iframe = document.createElement('iframe');
        iframe.src = (embed.indexOf('?')>-1 ? embed + '&autoplay=1' : embed + '?autoplay=1');
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.loading = 'lazy';
        iframe.title = 'Video player';
        lazy.innerHTML = '';
        lazy.appendChild(iframe);
        lazy.classList.add('playing');
        wrap.classList.add('is-playing');
      });
    }
  });
})();